<script setup lang="ts">
import type { KjdsListPageProps } from '@/types/appTypes'

const props = withDefaults(defineProps<KjdsListPageProps>(), {})

console.log('article: kjdsPageConfig', props.kjdsPageConfig)

const app = useNuxtApp()
const storeArticleList = useStoreArticleList()
const storeIndex = useStoreIndex()

const pageData = { items: [] as Article[] }

const setHead = () => {
  const baseTitle = 'なるほど！ミュージアム'
  const headDescription = `今日は何の日？ミュージアムに関する豆知識・トリビアを紹介。アートやアーティストの記念日、出来事、事件を知れば、これであなたもミュージアム通。`

  storeIndex.setBreadCrumbs([
    {
      text: baseTitle,
      disabled: true,
    },
  ])

  const headInput = app.$makeMeta({
    title: baseTitle,
    description: headDescription,
  })
  useHead(headInput)
}

const isDate = (index) => {
  if (index > 0) {
    const itemPrev = pageData.items[index - 1]
    const item = pageData.items[index]
    if (useDayjs(itemPrev.open_date).isSame(item.open_date, 'day')) {
      return false
    }
  }
  return true
}

const initPage = async () => {
  const [resSite, resMaster, resList] = await Promise.all([
    storeIndex.fetchSite(),
    storeIndex.fetchMaster(),
    storeArticleList.fetchList(props.kjdsPageConfig.list.mainListName),
  ])
  pageData.items = resList.data.articles as Article[]

  console.log('article: initPage', pageData)
}
await initPage()
setHead()
</script>

<template>
  <div class="p-articlePage">
    <h2 class="c-heading_page">
      なるほど！ミュージアム
    </h2>

    <div class="p-main_result">
      <div class="p-articlePage_list">
        <template
          v-for="(item, index) in pageData.items"
          v-bind:key="item.id"
        >
          <NaruhodoItem
            v-bind:item="item"
            v-bind:is-date="isDate(index)"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.p-main {
  &_result {
    position: relative;
  }
}
</style>
